import { parse as parseQs } from "qs";
import React from "react";
import { useIntl } from "react-intl";
import { Route, Routes, useLocation } from "react-router-dom";

import { WindowTitle } from "../../components/WindowTitle";
import StoreOrdersBiListComponent from "./views/StoreOrdersBiList";

const StoreOrdersBiList: React.FC = () => {
  const location = useLocation();
  const params = parseQs(location.search.substr(1));

  return <StoreOrdersBiListComponent params={params} />;
};

const Component = () => {
  const intl = useIntl();
  return (
    <>
      <WindowTitle
        title={intl.formatMessage({
          defaultMessage: "Store Orders",
          description: "store orders section"
        })}
      />
      <Routes>
        <Route path={""} element={<StoreOrdersBiList />} />
      </Routes>
    </>
  );
};

export default Component;
